import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import { Input } from '../Input';

export const Popup = ({ children, closeFn, title, button, style = {}, closeWithOutsideClick = true }) => {
    const outsideClickHandler = (evt) => {
        evt.target === evt.currentTarget && closeFn();
    };

    return createPortal(
        <div className="popup-wrapper" onMouseDown={closeWithOutsideClick ? outsideClickHandler : null}>
            <div className="popup dark-theme-bg0" style={style}>
                <div className="popup__header">
                    <h3 className="popup__title">{title}</h3>
                    <div className="popup__close-button" onClick={closeFn}>x</div>
                </div>
                <div className="popup__body">{children}</div>
                <div className="popup__footer">{button}</div>
            </div>
        </div>,
        document.getElementById('popup-root'),
    );
};
